//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Inform from "@/components/layer/inform.vue";
import { creatOrder, priceList } from "@/model/trader/orderService";
import { passport, loginMobile } from "@/model/api/loginService.js";
import {
  Login,
  customerLink,
  CacheModule,
  paySystem,
} from "@/utils/commonUtils";
import { phoneReg, nameReg, codeReg } from "@/utils/regular.js";
import Insureinfo from "@/components/toast/insureInfo";
import { discount } from "@/model/coupon/couponServer.js";
import { store, mutations } from "@/observable/store";
import IDcard from "@/components/input/IDcard.vue";
import inputName from "@/components/input/inputName.vue";
import inputPhone from "@/components/input/inputPhone.vue";
import Instructions from "./instructions.vue";
import InstructionProtocol from "@/components/instructionProtocol/index.vue";
import NewProtocol from '@/components/newProtocol/index.vue'
import { FactoryUtils } from "@/utils/FactoryUtils";
import premium from "@/components/layer/premium";
import social from "@/components/layer/social";
import { toApp } from "@/utils/appBridge";
import { skipHerf } from "@/utils/commonUtils";
import { Parameter } from "@/utils/orderParme";
import Txrweb from "@/utils/mixin/mixinTxrweb";
import InsuranceReview from '@/utils/mixin/InsuranceReview'
import { customer } from '@/utils/customer/index.js'

export default {
  name: "illustrate",
  mixins: [Txrweb,InsuranceReview],
  data() {
    return {
      applicantPhoneVerify: false,
      applicantPhoneInfo: {},
      applicantPhonePlaceholder: "请填写您的手机号码",
      insuresNameInfo: {},
      insuresNameVerify: false,
      insuresNamePlaceholder: "请填写TA的姓名",
      applicantNamePlaceholder: "请填写您的姓名",
      applicantNameVerify: false, // 被保人姓名
      applicantNameInfo: {}, //投保人姓名
      insuresIDcardPlaceholder: "请填写TA的身份证号",
      insuresIDcardVerify: false, //被保人错误提示
      insuresIDcardInfo: {}, // 被保人身份证信息
      applicantIDcardPlaceholder: "请填写您的身份证号",
      applicantIDcardVerify: false, // 投保人错误提示
      applicantIDcardInfo: {}, // 投保人身份证信息
      planA: false,
      // insureFlag:'', // 投保人标示 insureFlag
      templateFlag: "tk_irok", // 保险标示
      applicantPhone: "",
      applicantCode: "", //验证码
      insureList: [
        { name: "本人", flag: "self" },
        { name: "子女", flag: "children" },
        { name: "配偶", flag: "couple" },
        { name: "父母", flag: "parent" },
      ],
      socialList: [],
      periodList: [], // 年交 月交
      payPeriod: "year", // 年缴,
      payAction: "paid", //支付方式
      insureFlg: 0,
      socialFlg: 2, //0有社保 - 1无社保 - 2有无社保未选择
      periodFlg: 0, // 月交 年交
      // insureUserphone:false,//投保人手机号
      append_pattern: 0, //附加保障
      // selectFlag: false, //须知
      Verification: false,
      amount: null, //金额
      amountPrice: null, //金额
      couponList: [], //优惠券列表
      customerUrl: null,
      codeClickFlag: true,
      showTime: true,
      count: "",
      timer: null,
      btnFoodFlag: false,
      navTitleFlag: false,
      getCodeFlag: true, // 验证码登录成功标识
      isIPhoneX: false,
      htObj: {}, //华泰支付收银
      fromInfo: {},
      treaty: {}, //协议
      security: 1, //有无社保
      bwprice: [], //百万医疗有无社保应付金额
      priceData: null, // 价格列表
      bwperiodPrice: [], //百万医疗有无社保 年月 应付金额
      mountPriceList: ["", "", ""], //月付价格数组
      mountPrice: null, // 月付价格
      foodImg: "https://static.soyoung.com/sy-pre/food-1589530201589.png",
      payable_amount: 0,
      protocolInfo:{}
    };
  },
  props: {
    insureInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    relationFlag: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  components: {
    Insureinfo,
    IDcard,
    inputName,
    inputPhone,
    Instructions,
    InstructionProtocol,
    NewProtocol,
    premium,
    social,
    Inform,
  },
  computed: {
    uid() {
      return store.uid;
    },
    syToken() {
      return store.syToken;
    },
    loginPhone() {
      return store.phone;
    },
  },
  watch: {
    applicantCode(val) {
      //console.log('valll',val,val.length)
      this.Verification = false;
      // 判断手机号是否正确
      // 判断验证码是否位纯数字
      this.applicantCode = this.applicantCode.trim();
      let codeTest = codeReg.test(this.applicantCode);
      // 登录
      //console.log('his.applicantPhoneInfo',this.applicantPhoneInfo)
      if (
        this.applicantPhoneInfo &&
        this.applicantPhoneInfo.phoneFlag &&
        val.length > 5 &&
        codeTest
      ) {
        this.login();
      }
    },
    templateFlag(newValue, oldValue) {
      if (newValue == "ht_cc") {
        this.insureClick(1);
      }
    },
    // applicantPhone(newValue, oldValue){     //本人的手机
    //     this.insureUserphone = false;
    // },
  },
  created() {
    if (this.$route.path == "/detailsA") {
      this.planA = true;
    }
    if (this.$route.query.templateFlag) {
      this.templateFlag = this.$route.query.templateFlag;
    }

    this.isIPhoneX = this.IPHONEX;
    // 客服
    customerLink(this.templateFlag).then((data) => {
      //console.log('customer', data)
      this.customerUrl = data;
      return data;
    });
    //  静态文案
    FactoryUtils.fromInfo().then((res) => {
      this.fromInfo = res;
      this.socialList = res.socialList;
      this.periodList = res.periodList;
      this.treaty = res.treaty;
      if (this.insureInfo.cache) {
        let foodImg = JSON.parse(this.insureInfo.cache);
        this.foodImg = foodImg.food_img;
      } else {
        console.log("this.fromInfo", this.fromInfo);
        this.foodImg = this.fromInfo.foodImg;
      }
    });
  },
  mounted() {
    if (this.insureInfo.payable_amount) {
      this.payable_amount = this.insureInfo.payable_amount / 100;
    }
    let lastIdentityInfo = this.insureInfo.last_identity_info;
    if (lastIdentityInfo) {
      this.$nextTick(() => {
        //当 $emit 先于 $on 执行的时候 接受不到监听
        setTimeout(() => {
          this.bus.$emit("nameInputFlag", lastIdentityInfo.applicant_name);
          this.bus.$emit("idCardInputFlag", lastIdentityInfo.applicant_idcard);
          if (lastIdentityInfo.applicant_phone) {
            this.bus.$emit("phoneInputFlag", lastIdentityInfo.applicant_phone);
            // this.socialFlg = lastIdentityInfo.social_security
            if (lastIdentityInfo.social_security == "1") {
              this.socialFlg = 0;
            }
          }
          this.$refs.insuresCard ? this.$refs.insuresCard.cleanInfo() : "";
          this.$refs.insuresName ? this.$refs.insuresName.cleanInfo() : "";

          if(this.templateFlag == 'ht_cc' || this.templateFlag == "ta_tw"){//童牙保 天安洗牙读取缓存
              // console.log()
              const info = CacheModule.getUserInfo('ht_ccInfo')
              if(info){
                this.bus.$emit("phoneInputFlag", info.benren.phone);
                this.bus.$emit("nameInputFlag", info.benren.name);
                this.bus.$emit("idCardInputFlag", info.benren.idcard);
                this.$refs.insuresCard ? this.$refs.insuresCard.cleanInfo(info.zinv.idcard) : "";
                this.$refs.insuresName ? this.$refs.insuresName.cleanInfo(info.zinv.name) : "";
                CacheModule.remove('ht_ccInfo')
              }

          }
        });
      });
    }
    this.couponList = this.insureInfo.coupon;
    this.amount = this.insureInfo.amount;
    this.amountPrice = this.insureInfo.amountPrice;
    // if(this.templateFlag == "zh_mil"){
    //   this.amountPrice = this.insureInfo.amountPrice
    // }
    this.bwprice = [this.amountPrice, this.amountPrice, this.amountPrice]; // 默认情况下 有社保 ，无社保，有无社保未选择 的价格数组
    // 判断时候是月交
    if (this.insureInfo.stage_info.stage_active === 1) {
      this.payPeriod = "month"; // 月交,
      this.payAction = "entrust"; //分期
    } else {
      this.periodFlg = 1;
    }
    if (this.templateFlag == "tk_mil") {
      let stageInfo = this.insureInfo.stage_info;
      if (stageInfo.stage_active == 1) {
        if (stageInfo.stage_type == "fixed") {
          this.amountPrice = stageInfo.first_amount / 100;
        }
        if (stageInfo.stage_type == "default") {
          this.amountPrice = stageInfo.amount / 100;
        }
      }
      this.amount = this.amountPrice;
    }
    this.scrollInto();
  },
  methods: {
    premiumClick() {
      //保费明细
      this.$refs.premiumRef.showToast();
      this.STATISTICS("click", "sybao_ins_proinfo_premiumdetail_click");
    },
    socialInfo() {
      this.STATISTICS("click", "sybao_ins_proinfo_insurancedesc_click");
      this.$refs.socialRef.showToast();
    },
    applicantPhoneEmit(msg) {
      this.applicantPhoneVerify = false;
      this.applicantPhoneInfo = msg;
    },
    applicantNameEmit(msg) {
      this.applicantNameVerify = false;
      this.applicantNameInfo = msg;
    },
    applicantIDcardEmit(msg) {
      //投保人身份证号
      this.applicantIDcardVerify = false;
      this.applicantIDcardInfo = msg;
      if (this.insureFlg == 0) {
        //  投保人为被保人
        this.getpriceLIst(msg);
      }
    },
    getpriceLIst(msg) {
      //根据被保人身份信息获取价格
      if (
        (msg.idCardFlag && this.templateFlag == "zh_mil") ||
        (msg.idCardFlag && this.templateFlag == "tk_mil")
      ) {
        let data = { 
          idcard: msg.idcard, 
          template: this.templateFlag,
          last_policy_id:this.insureInfo.last_identity_info.policy_id || 0
        }
        priceList(data)
          .then((data) => {
            console.log("data", data);
            this.priceData = data;
            if (this.templateFlag == "tk_mil") {
              this.priceText(data);
            }
            if (this.templateFlag == "zh_mil") {
              this.bwprice = [
                data.social_security.year_amount / 100,
                data.without_social_security.year_amount / 100,
                this.insureInfo.amountPrice,
              ];
              this.amount = this.amountPrice = this.bwprice[this.socialFlg];
            }
          })
          .catch((res) => {
            this.$toast(res.message);
            this.addPattern(res.code);
          });
      }
    },
    insuresNameEmit(msg) {
      //console.log('insuresNameVerify', msg)
      this.insuresNameVerify = false;
      this.insuresNameInfo = msg;
    },
    insuresIDcardEmit(msg) {
      // 被保人身份证号
      this.insuresIDcardVerify = false;
      this.insuresIDcardInfo = msg;
      this.getpriceLIst(msg);
    },
    // 价格显示判断
    priceText(m) {
      console.log("价格显示判断", m);
      this.bwperiodPrice = [
        [
          m.social_security.first_month_amount / 100
            ? m.social_security.first_month_amount / 100
            : m.social_security.month_amount / 100,
          m.without_social_security.first_month_amount / 100
            ? m.without_social_security.first_month_amount / 100
            : m.without_social_security.month_amount / 100,
          this.insureInfo.amountPrice,
        ],
        [
          m.social_security.year_amount / 100,
          m.without_social_security.year_amount / 100,
          this.insureInfo.amountPrice,
        ],
      ];
      this.amount = this.amountPrice = this.bwperiodPrice[this.periodFlg][
        this.socialFlg
      ];
      this.mountPriceList = [
        m.social_security.month_amount / 100,
        m.without_social_security.month_amount / 100,
        "",
      ];
      this.mountPrice = this.mountPriceList[this.socialFlg];
    },
    periodClick(e) {
      this.periodFlg = e;
      this.payPeriod = this.periodList[e].periodFlag;
      this.payAction = this.periodList[e].payAction;
      this.amount = this.amountPrice = this.bwperiodPrice[e][this.socialFlg];
    },
    insureClick(e) {
      //投保人切换
      if (e != this.insureFlg) {
        this.insureFlg = e;
        this.$refs.insuresCard ? this.$refs.insuresCard.cleanInfo() : "";
        this.$refs.insuresName ? this.$refs.insuresName.cleanInfo() : "";
        //  百万医疗切换时 重置身份证 及付款价格 。
        if (this.templateFlag == "zh_mil") {
          // this.$refs.TbinsuresCard.cleanInfo()
          this.bwprice = [
            this.insureInfo.amountPrice,
            this.insureInfo.amountPrice,
            this.insureInfo.amountPrice,
          ]; // 默认情况下 有社保 ，无社保，有无社保未选择 的价格数组
          this.amount = this.amountPrice = this.bwprice[2];
        }
      }
    },
    socialClick(e) {
      //切换有无社保
      if (e) {
        // 0 无社保
        this.STATISTICS("click", "sybao_ins_proinfo_amrr_click");
      } else {
        this.STATISTICS("click", "sybao_ins_proinfo_social_insurance_click");
      }
      if (e != this.socialFlg) {
        this.socialFlg = e;
        this.security = this.socialList[e].key;
        if (this.templateFlag == "zh_mil") {
          this.amount = this.amountPrice = this.bwprice[e];
        }
        if (this.templateFlag == "tk_mil") {
          if (this.bwperiodPrice.length > 0) {
            this.amount = this.amountPrice = this.bwperiodPrice[this.periodFlg][
              e
            ];
          }
          this.mountPrice = this.mountPriceList[this.socialFlg];
        }
      }
    },
    testUA(str) {
      return navigator.userAgent.indexOf(str) > -1;
    },
    scrollInto() {
      //处理软键盘问题
      var inputs = document.getElementsByTagName("input");
      for (var i = 0; i < inputs.length; i++) {
        inputs[i].onblur = function (e) {
          window.setTimeout(function () {
            const scrollHeight =
              document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollHeight) {
              window.scrollTo(0, Math.max(scrollHeight - 1, 0));
            }
          }, 0);
        };
      }
    },
    onBlur(data) {
      // 统计

      if (!data.inputText) {
        return false;
      }
      console.log(data);
      switch (data.message) {
        case "id":
          this.STATISTICS("click", "sybao_ins_proinfo_identity_click");
          break;
        case "name":
          this.STATISTICS("click", "sybao_ins_proinfo_name_click");
          break;
        case "phone":
          this.STATISTICS("click", "sybao_ins_proinfo_phone_click");
          break;
        case "holdername":
          this.STATISTICS("click", "sybao_ins_proinfo_holdername_click");
          break;
        case "holderid":
          this.STATISTICS("click", "sybao_ins_proinfo_holderidentity_click");
          break;
      }
    },
    insureToast() {
      this.$refs.insureRef.showoast();
    },
    custUrl() {
      this.STATISTICS("click", "sybao_ins_proinfo_contact_click");

        //童牙保 天安洗牙 直接跳转页面 跳转客服做缓存处理
        if(this.templateFlag == "ht_cc" || this.templateFlag == "ta_tw"){ 
          const benren =  {
            //投保人对象
            phone: this.applicantPhoneInfo.phone, //手机号
            name: this.applicantNameInfo.name, //姓名
            idcard: this.applicantIDcardInfo.idcard, //身份证号码
          }
          const zinv = {
            name: this.insuresNameInfo.name, //姓名
            idcard: this.insuresIDcardInfo.idcard, //身份证号码
          }
          CacheModule.set("ht_ccInfo",{benren,zinv})

          if(this.templateFlag == "ta_tw"){
            customer.udesk.showPanel()
            return false
          }
        }

      if (this.CHANNAL_ID == "APP") {
        if (this.IOS_AND == "IOS") {
          window.location.href = "app.soyoung://html?url=" + this.customerUrl;
        } else if (this.IOS_AND == "Android") {
          //判断Android
          console.log("Android");

          window.location.href = this.customerUrl +'&download_finish=true'
        }
      } else {
        //童牙保直接跳转页面 跳转客服做缓存处理
        if(this.templateFlag == "ht_cc"){
          window.location.href = this.customerUrl
        }else{
          this.$router.push({
            path: "/iframe",
            query: {
              urlkf: this.customerUrl,
              flag: "postdisable",
            },
          });
        }
        
      }
    },
    getCodeTime() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showTime = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showTime = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    getCode() {
      this.STATISTICS("click", "sybao_ins_proinfo_getvcode_click");
      if (this.applicantPhoneInfo && !this.applicantPhoneInfo.phoneFlag) {
        this.$toast("请填写您的手机号码");
        // this.applicantPhoneVerify = true;
        this.applicantPhoneVerify = true;
        return;
      }
      if (this.codeClickFlag) {
        this.codeClickFlag = false;
        Login.getlogin()
          .then((data) => {
            //console.log('data',data)
            this.getCodeTime();
            if (data && data.pass) {
              let parme = {
                phone: this.applicantPhoneInfo.phone,
                country_code: "86",
                // challenge: data.challenge,
                // sense_id: "39972a813f8696146efb3f2261cedfa1",
              };
              passport(parme)
                .then((data) => {
                  //console.log('data验证码获取成功',data)
                })
                .catch((err) => {
                  //console.log('data验证码获取失败',err)
                  this.$toast(err.message);
                });
            }
          })
          .catch((err) => {
            this.$toast(err.message);
          })
          .finally(() => {
            this.codeClickFlag = true;
          });
      }
    },
    login() {
      let codeData = {
        phone: this.applicantPhoneInfo.phone,
        country_code: "86",
        code: this.applicantCode,
        sys: "15",
      };
      loginMobile(codeData)
        .then((data) => {
          this.getCodeFlag = true;
          if (!this.planA) {
            discount(this.templateFlag).then((dataCoupon) => {
              //console.log('data登录成功',dataCoupon)
              if (dataCoupon.length > 0) {
                this.couponList = dataCoupon;
                for (let i of dataCoupon) {
                  this.amountPrice =
                    this.insureInfo.amountPrice - i.amount / 100;
                }
              }
            });
          }
          mutations.getsyToken(data.token);
          mutations.getUid(data.uid);
          let userInfo = {
            login_token: data.token,
            login_uid: data.uid,
            login_phone: data.phone,
            login_insure_uid:data.insure_uid
          };
          CacheModule.set("userInfo", userInfo);
          // CacheModule.getUserInfo('userInfo')
        })
        .catch((err) => {
          if ((err.code = 1001)) {
            this.Verification = true;
            this.$toast(err.message);
          }
          this.getCodeFlag = false;
          //console.log('data登录失败',err)
        });
    },

    appendPattern() {
      if (this.append_pattern) {
        this.append_pattern = 0;
        this.amount -= this.insureInfo.append_amount;
        this.amountPrice -= this.insureInfo.append_amount;
        this.payable_amount -= this.insureInfo.append_amount;
      } else {
        this.append_pattern = 1;
        this.amount += this.insureInfo.append_amount;
        this.amountPrice += this.insureInfo.append_amount;
        this.payable_amount += this.insureInfo.append_amount;
      }
    },
    navCLick(e) {
      if (e == 3) {
        this.navTitleFlag = true;
      } else {
        let _document = document.documentElement || document.body;
        if (
          _document.scrollHeight -
            this.$parent.scrollHand -
            _document.clientHeight <=
          10
        ) {
          this.navTitleFlag = true;
        } else {
          this.navTitleFlag = false;
        }

        // 适配app内 机型为iphonex  iphonexr iphonexs iphonexsmax
        if (this.CHANNAL_ID == "APP" && this.isIPhone) {
          if (
            _document.scrollHeight -
              this.$parent.scrollHand -
              _document.clientHeight <=
            60
          ) {
            this.navTitleFlag = true;
          }
        }
      }
    },
    submitClick(){
      this.$refs.instructionProtocol.selectFlag=true
      this.creat()
    },
    /** 触发购买逻辑 */
    creat() {
      this.STATISTICS("click", "sybao_ins_proinfo_pay_click");
      this.$parent.myBtn();

      if (!this.navTitleFlag) return;
      if (this.insureFlg) {
        if (this.insuresNameInfo && !this.insuresNameInfo.nameFlag) {
          this.$toast("请填写正确的姓名");
          this.insuresNameVerify = true;
          return;
        }
        if (this.insuresIDcardInfo && !this.insuresIDcardInfo.idCardFlag) {
          this.$toast("请填写正确的身份证号");
          this.insuresIDcardVerify = true;
          return;
        }
      }
      if (this.applicantNameInfo && !this.applicantNameInfo.nameFlag) {
        this.$toast("请填写正确的姓名");
        this.applicantNameVerify = true;
        return;
      }

      if (this.applicantIDcardInfo && !this.applicantIDcardInfo.idCardFlag) {
        this.$toast("请填写正确的身份证号");
        this.applicantIDcardVerify = true;
        return;
      }
      if (this.applicantPhoneInfo && !this.applicantPhoneInfo.phoneFlag) {
        this.$toast("请填写您的手机号码");
        this.applicantPhoneVerify = true;
        return;
      }
      //console.log('this.loginPhone',this.loginPhone)
      if (!this.syToken || this.syToken == 0) {
        this.applicantCode = this.applicantCode.trim();
        let codeFlag = codeReg.test(this.applicantCode);
        if (!codeFlag) {
          this.$toast("请填写验证码");
          this.Verification = true;
          return;
        }
      }
      if (
        this.socialList &&
        this.socialList.length > 0 &&
        this.socialFlg == 2
      ) {
        this.$toast("请选择有无社保");
        return;
      }
      this.$refs.instructionProtocol.checkSelectFlag()
      .then((res)=>{
        if(res){
          if (!this.getCodeFlag) {
            this.$toast("验证码错误");
            this.Verification = true;
            this.applicantCode = "";
            return;
          }
          // 判断价格切换时 使用支付价格
          if (this.templateFlag == "zh_mil" || this.templateFlag == "tk_mil") {
            this.payable_amount = this.amountPrice;
          }
          if (this.payPeriod == "month") {
            this.append_pattern = 5;
          }
          let modify;
          if (this.$route.path == "/detailsA") {
            modify = "23k";
          } else {
            if (this.$route.query.modify) {
              modify = this.$route.query.modify;
            } else {
              modify = "";
            }
          }

          let parmer = {
            modify: modify,
            pay_period: this.payPeriod, // 年缴,
            source: 1, //来源id
            applicant: {
              //投保人对象
              phone: this.applicantPhoneInfo.phone, //手机号
              name: this.applicantNameInfo.name, //姓名
              idcard: this.applicantIDcardInfo.idcard, //身份证号码
            },
            insure: [
              {
                //被保人对象
                phone: this.applicantPhoneInfo.phone, //手机号 目前是空
                name: this.insuresNameInfo.name, //姓名
                idcard: this.insuresIDcardInfo.idcard, //身份证号码
                coverage: 600000000, //保额
                relation: this.insureList[this.insureFlg].flag, //被保人
                social_security: this.security, //0-无社保, 1-有社保
                amount: this.amountPrice, //实付金额
                payable_amount: this.payable_amount, //应付金额
                extra_enums: this.append_pattern, //0-无操作, 1-智齿拔除意外
              },
            ],
            template: this.templateFlag, // 接口名
            pay_action: this.payAction, //支付方式(paid-支付, entrust-签约代扣)
            amount: this.amountPrice, //实付金额
            payable_amount: this.payable_amount, //应付金额
            from_salesman: this.$route.query.from_salesman || "",
            traceback: store.TXoption.bizKey,
            stage_active:this.insureInfo.stage_info.stage_active, //是否签约 用于在核保页判断是否签约
            last_policy_id:this.insureInfo.last_identity_info.policy_id || 0
          };
          const parameter = Parameter(parmer);
          // 核保
          this.insuranceToReview(parameter,'creatOrder')
        }else{
          this.protocolInfo={
            productName:"童牙保(互联网)",   //童牙保保险方案写死
            buyerName:this.applicantNameInfo.name,
            insuredName:this.insuresNameInfo.name
          }
          this.$refs.newProtocol.modeShow=true
        }
      })
      .catch(err=>{
         console.log(err)
      })
    },
    addHeight() {
      if (this.$refs.insureFn.offsetHeight - document.body.offsetHeight < 0) {
        this.$refs.insureFn.style.minHeight =
          document.body.offsetHeight - this.$parent.navHeight + "px";
      }
    },
    addPattern(code) {
      //根据接口返回投保年龄错误 增加错误样式
      if (code == 1112) {
        //投保人身份信息出错
        this.applicantIDcardVerify = true;
      } else if (code == 1111) {
        //被保人身份信息出错
        if (this.insureFlg == 0) {
          //投保人 = 被保人
          this.applicantIDcardVerify = true;
        } else {
          this.insuresIDcardVerify = true;
        }
      }
    },
  },
};
